import { defineMessages } from 'react-intl';

export default defineMessages({
  remainingCharacters: {
    id: 'view.DeliveryManagement.remainingChars',
    defaultMessage: 'Remaining characters: {length}',
  },
});
